<div class='info-list-2'>
  <info-list-item
    *ngFor='let contentType of data'
    label='{{ contentType }}'
    [showIfNoValue]='true'
    [labelTooltip]='tooltipMap[ contentType ]'>

  </info-list-item>
</div>
